'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var SpMenu;
(function (SpMenu) {
    var MySpMenu = /** @class */ (function () {
        function MySpMenu() {
            var self = this;
            $('.trigSwitchBtn').on('click', function () {
                var openFlag = Number($('.paramSwitchMenu').attr('data-open'));
                if (openFlag == 0) {
                    $('.bulletChangeIcon').addClass('active');
                    $('.bulletSwitchMenu').fadeIn('slow', function () {
                        $('.paramSwitchMenu').attr('data-open', 1);
                    });
                }
                else {
                    $('.bulletChangeIcon').removeClass('active');
                    $('.bulletSwitchMenu').fadeOut('slow', function () {
                        $('.paramSwitchMenu').attr('data-open', 0);
                    });
                }
            });
        }
        return MySpMenu;
    }());
    SpMenu.MySpMenu = MySpMenu;
})(SpMenu || (SpMenu = {}));
exports.default = SpMenu;
